import PropTypes from 'prop-types';


// @todo ADD TESTS
export const addressShape = {
  postOfficeBoxNumber: PropTypes.string,
  streetAddress:       PropTypes.string,
  addressLocality:     PropTypes.string,
  addressRegion:       PropTypes.string,
  postalCode:          PropTypes.string,
  addressCountry:      PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/domain/address.js